import React, { useState, useEffect } from "react";
import { YMaps } from "@pbe/react-yandex-maps";
import Modal from "../comman/modal.js";
import Map from "./Map.js";
import AddressSearch from "./AddressSearch.js";
import { YMAP_KEY } from "../../constants/index.js";
import { useLanguage } from "../../utils/languageContext.js";
import { getTranslation } from "../../utils/translate.js";

const MapDialog = ({ trigger, onApplyAddress, open: controlledOpen, onOpenChange, initialCoordinates }) => {
    const { language } = useLanguage();
    const [internalOpen, setInternalOpen] = useState(false);
    
    // Use controlled open state if provided, otherwise use internal state
    const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
    const setOpen = onOpenChange || setInternalOpen;

    // Check if API key is configured
    useEffect(() => {
        if (!YMAP_KEY || YMAP_KEY.trim() === '') {
            console.error('Yandex Maps API key is not configured. Please set REACT_APP_YMAP_KEY environment variable.');
        }
    }, []);

    const handleApplyAddress = (callback) => {
        onApplyAddress(() => {
            if (callback) callback();
            setOpen(false);
        });
    };

    return (
        <>
            {trigger && (
                <div onClick={() => setOpen(true)}>
                    {trigger}
                </div>
            )}
            <Modal
                isOpen={open}
                onClose={() => setOpen(false)}
                title={getTranslation('profile.selectAddress', language) || "Select Address"}
                size="4xl"
            >
                <div className="pt-2">
                    <div className="flex gap-2 items-center mb-6">
                        <AddressSearch onApplyAddress={handleApplyAddress} />
                    </div>
                    <YMaps query={{ lang: "en_US", apikey: YMAP_KEY }}>
                        <Map initialCoordinates={initialCoordinates} />
                    </YMaps>
                </div>
            </Modal>
        </>
    );
};

export default MapDialog;

